import { APIURL } from "../../constantes.js";
import { CarreraDTO } from "../DTOS/Carrera.dto.js";
import { CarreraBasicaDTO } from "../DTOS/CarreraBasica.dto.js";

export class CarrerasServicio {
    async ObtenerCarreras() {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/carreras/`, {
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "GET",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return [];
        }

        return respuesta.map(value => {
            const dto = new CarreraDTO();
            dto.cargarDTO(value);
            return dto;
        });
    }

    async EliminarCarrera(id) {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/carreras/${id}`, {
            body: JSON.stringify({
            }),
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "DELETE",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return [];
        }

        return respuesta.map(value => {
            const dto = new CarreraBasicaDTO();
            dto.cargarDTO(value);
            return dto;
        });
    }

    async ObtenerCarrera(id) {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/carreras/${id}`, {
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "GET",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return new CarreraDTO();
        }

        const dto = new CarreraDTO();
        dto.cargarDTO(respuesta);
        return dto;
    }

    async ObtenerCarrerasBasicas() {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/carreras/basicas`, {
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "GET",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return [];
        }

        return respuesta.map(value => {
            const dto = new CarreraBasicaDTO();
            dto.cargarDTO(value);
            return dto;
        });
    }

    async AgregarCarrera(carrera) {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/carreras/`, {
            body: JSON.stringify({
                carrera : JSON.stringify(carrera),
            }),
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "POST",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return [];
        }

        return respuesta.map(value => {
            const dto = new CarreraBasicaDTO();
            dto.cargarDTO(value);
            return dto;
        });
    }

    async GuardarCarrera(carrera,id) {
        const tokenLogin = localStorage.getItem("token");
        await fetch(`${APIURL}/carreras/${id}`, {
            body: JSON.stringify({
                carrera : JSON.stringify(carrera),
            }),
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "PUT",
            mode: "cors",
        });
    }

}
